import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "onboarding-text__image-wrapper" }
const _hoisted_2 = ["src", "width", "height"]

import { computed } from 'vue'

import { QuestionnaireView, getImage } from '@/models/onboarding'
import { TextPage } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Layout from '../Layout.vue'
import Rive from '@/app/components/Rive.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as TextPage
})

const image = computed(() => {
  if (!page.value.image) {
    return
  }
  return getImage(page.value.image.src)
})

const animation = computed(() => {
  if (!page.value.animation) {
    return
  }
  return getImage(page.value.animation.src)
})

const imageAnimationClass = computed(() => {
  if (!page.value.imageAnimation) {
    return ''
  }
  return `onboarding-text__image--${page.value.imageAnimation}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    id: page.value.id,
    class: _normalizeClass(["onboarding-text", {
      'onboarding-text--text-large': page.value.textSize === 'large',
      'onboarding-text--text-left': page.value.textAlignment === 'left',
    }]),
    title: page.value.title,
    subtitle: page.value.subtitle
  }, {
    aboveTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (page.value.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(["onboarding-text__image", imageAnimationClass.value]),
              src: image.value,
              width: page.value.image.width,
              height: page.value.image.height,
              alt: ""
            }, null, 10, _hoisted_2))
          : (page.value.animation)
            ? (_openBlock(), _createBlock(Rive, {
                key: 1,
                class: "onboarding-text__animation",
                src: animation.value!,
                width: page.value.animation.width,
                height: page.value.animation.height,
                stateMachines: page.value.animation.stateMachines
              }, null, 8, ["src", "width", "height", "stateMachines"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["id", "class", "title", "subtitle"]))
}
}

})